import {actionTypes} from '@/core/constants'
import api from '@/core/apiclient'

export default {

    async [actionTypes.ORCAMENTO.BUSCAR_TODOS_ORCAMENTOS]({state}, pacienteId) {
        const {filtros, paginacao} = state.resultadoBuscaTodosOrcamentosFicha
        filtros.pacienteId.value = pacienteId
        const {data} = await api.orcamento.buscarTodos(filtros, paginacao)
        return data
    },

    async [actionTypes.ORCAMENTO.CADASTRAR_ORCAMENTOS](context, dados) {
        const {data} = await api.orcamento.cadastrar(dados)
        return data
    },

    async [actionTypes.ORCAMENTO.EDITAR_ORCAMENTOS](context, dados) {
        const {data} = await api.orcamento.editar(dados)
        return data
    },

    async [actionTypes.ORCAMENTO.EXCLUIR_ORCAMENTOS](context, id) {
        await api.orcamento.excluir(id)
    },

    async [actionTypes.ORCAMENTO.ATUALIZAR_STATUS](context, dados) {
        return await api.orcamento.atualizarStatus(dados)
    },
}